// @ts-nocheck
// Hooks
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useClearDataToast } from 'src/clientLib/hooks'
import { useNavigationEffect } from 'src/redux/slices/navigation/hooks'

import { clearUserFiles } from 'src/redux/services/ubem'
import {
  mutationFixedCacheKeys,
  uploadBaseUpgradingFile,
} from 'src/redux/slices/upgrades/endpoints'
import { clearAllData } from 'src/redux/slices/upgrades/reducers'
import { selectTemplates } from 'src/redux/slices/upgrades/selectors'

import { RtkDropzone } from 'src/components/RtkDropzone'

export default () => {
  const dispatch = useDispatch()
  const [triggerClearUserFiles, __] = clearUserFiles.useMutation()
  const templates = useSelector(selectTemplates)

  useClearDataToast({ data: templates })
  useNavigationEffect({ destination: 'assign', condition: templates })

  useEffect(() => {
    // triggerClearUserFiles()
    dispatch(clearAllData())
  }, [dispatch, triggerClearUserFiles])

  return (
    <RtkDropzone
      mutation={uploadBaseUpgradingFile.useMutation}
      index={mutationFixedCacheKeys.uploadBaseUpgradingFile}
      accept='application/zip, application/x-zip-compressed, multipart/x-zip, .umi, application/json, .json'
      maxFiles={1}
      skipReset={true}
    />
  )
}
